import _ from 'lodash';
import { useEffect, useState } from 'react';
import {EIDealClientHeader, EIDealHeader} from "../../utils/eiFormatters"

export const EIDeal = {
    id: 'EIDeal',
    // tabs: ['common', 'chat', 'logs'],
    tabs: ['common', 'moveGuide', 'logs'],
    defaultTab: 'common',
    statuses: [
      {id: "pik_goods", groupname: 'Забор'},
      {id: "moving_deals", groupname: 'Движение'},
      {id: "products_storage", groupname: 'Хранение'},
      {id: "products_shipment", groupname: 'Отгрузка'}
    ],
    header: EIDealHeader,
  };

export const EIDealNoStatus = {
    id: 'EIDealNoStatus',
    // tabs: ['common', 'chat', 'logs'],
    tabs: ['common', 'logs'],
    defaultTab: 'common',
    header: EIDealHeader,
  };

export const EIDealFBS = {
    id: 'EIDealFBS',
    tabs: ['common', 'logs'],
    defaultTab: 'common',
    header: EIDealHeader,
  };

export const EIProduct = {
    id: 'EIProduct',
    tabs: ['productInfo'],
    defaultTab: 'productInfo',
    // header: EIDealHeader,
  };


//todo
// {deal:DEAL, box:BOX, count:count, product:{nmID: card.nmID, size: card.size, data:card.data}}
export const moveGuide = {
  id: 'moveGuide',
  api: 'marketsBridge',
  items: [
    { id: 'product.data', title: 'Товар', formatter: 'Product' },
    { id: 'info', title: 'Информация', formatter: 'HowMoveInfo' },
    { id: 'from', title: 'Забрать из', formatter: 'HowMove'},
  ],
};

export const packageSelect = {
  id: 'packageSelect',
  api: 'marketsBridge',
  showCheckboxes: true,
  items: [
    { id: 'photo', title: 'Фото', formatter: 'LittleImageFormatProduct'},
    { id: 'name', title: 'Расходники', formatter: 'DefaultTypographyMid'},
    { id: 'size', title: 'Размер', formatter: 'DefaultTypography' },
    { id: 'color', title: 'Цвет', formatter: 'DefaultTypography' },
    { id: ['count', 'rck'], title: 'Кол.', formatter: 'ProductCountWithUnitsType', width:'70px'},
  ],
};

export const packageSelectNoEdit = {
  id: 'packageSelectNoEdit',
  api: 'marketsBridge',
  showCheckboxes: true,
  items: [
    { id: 'photo', title: 'Фото', formatter: 'LittleImageFormatProduct'},
    { id: 'name', title: 'Расходники', formatter: 'DefaultTypographyMid'},
    { id: 'size', title: 'Размер', formatter: 'DefaultTypography' },
    { id: 'color', title: 'Цвет', formatter: 'DefaultTypography' },
    { id: ['count', 'rck'], title: 'Кол.', formatter: 'ProductCountWithUnitsTypeNoEdit', width:'70px'},
  ],
};

export const packageSelectOnlyCheck = {
  id: 'packageSelectOnlyCheck',
  api: 'marketsBridge',
  showCheckboxes: true,
  items: [
    { id: 'photo', title: 'Фото', formatter: 'LittleImageFormatProduct'},
    { id: 'name', title: 'Расходники', formatter: 'DefaultTypographyMid'},
    { id: 'size', title: 'Размер', formatter: 'DefaultTypography' },
    { id: 'color', title: 'Цвет', formatter: 'DefaultTypography' },
  ],
};

export const otherServiceDS = {
  id: 'otherServiceDS',
  api: 'marketsBridge',
  showCheckboxes: false,
  items: [
    { id: 'name', title: 'Расходники', formatter: 'DefaultTypographyMid'},
    { id: 'data.count', title: 'Кол.', formatter: 'ProductCount', width:'30px'},
  ],
};

export const otherServiceDSNoEdit = {
  id: 'otherServiceDSNoEdit',
  api: 'marketsBridge',
  showCheckboxes: false,
  items: [
    { id: 'name', title: 'Расходники', formatter: 'DefaultTypographyMid'},
    { id: 'data.count', title: 'Кол.', formatter: 'ProductCountNoEdit', width:'30px'},
  ],
};

export const tagSelect = {
  id: 'tagSelect',
  api: 'marketsBridge',
  showCheckboxes: true,
  items: [
    { id: 'name', title: 'Тип этикетки', formatter: 'DefaultTypographyMid'},
  ],
};

export const consumeSelect = {
  id: 'consumeSelect',
  api: 'marketsBridge',
  showCheckboxes: true,
  items: [
    { id: 'photo', title: 'Фото', formatter: 'LittleImageFormatProduct'},
    { id: 'name', title: 'Расходники', formatter: 'DefaultTypographyMid'},
    { id: 'size', title: 'Размер', formatter: 'DefaultTypography' },
    { id: 'color', title: 'Цвет', formatter: 'DefaultTypography' },
    { id: ['count', 'rck'], title: 'Кол.', formatter: 'ProductCountWithUnitsType', width:'70px'},
  ],
};
export const consumeSelectNoEdit = {
  id: 'consumeSelectNoEdit',
  api: 'marketsBridge',
  showCheckboxes: true,
  items: [
    { id: 'photo', title: 'Фото', formatter: 'LittleImageFormatProduct'},
    { id: 'name', title: 'Расходники', formatter: 'DefaultTypographyMid'},
    { id: 'size', title: 'Размер', formatter: 'DefaultTypography' },
    { id: 'color', title: 'Цвет', formatter: 'DefaultTypography' },
    { id: ['count', 'rck'], title: 'Кол.', formatter: 'ProductCountWithUnitsTypeNoEdit', width:'70px'},
  ],
};


export const EICreateDelivery = {
    id: 'EICreateDelivery',
    tabs: ['CreateDelivery'],
    defaultTab: 'CreateDelivery',
    header: EIDealClientHeader,
  };

export const CliInfo = {
    id: 'CliInfo',
    tabs: ['CliInfo'],
    defaultTab: 'CliInfo',
  };

export const unity_deal = {
  id: 'unity_deal',
  tabs: ['unity_deal', 'unity_deal_deals'],
  defaultTab: 'unity_deal_deals',
};

export const ReturnsDealsAdmin = {
  id: 'ReturnsDealsAdmin',
  tabs: ['returns_deals', 'selfreturns_deals'],
  defaultTab: 'returns_deals',
};

export const CreateDeliveryEI = {
  id: 'createDeliveryEI',
  api: 'productsClientBridge',
  title: 'Создать поставку',
  // отображать чекбоксы для выбора строк
  showCheckboxes: false,
  items: [
    { id: 'data.cdn', title: '№', width:'10px' },
    { id: 'data.units', title: 'Кол-во единиц', formatter: 'DefaultTypography', width:'70px'},
    { id: 'data.sku', title: 'SKU', formatter: 'DefaultTypography', width:'20px'},
    { id: 'date_shipment', title: 'Дата отгрузки', formatter:"date" , width:'50px'},
    { id: 'status_pay', title: 'Статус оплаты', formatter: "StatusPay", width:'140px' },
    { id: 'type', title: 'Статус сделки', formatter: "StatusDeal" , width:'100px'},
    { id: 'dealDetails', title: 'Детали', formatter: "DealDetails"},
  ],
};

export const ClientSettings = {
    id: 'ClientSettings',
    title: 'Настройки',
    tabs: ['ClientSettings', 'ClientDocumentsSettings', 'ClientAPISettings'],
    defaultTab: 'ClientSettings',
        
};